/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The type of initiator that initiated the action.
*/
export enum AuditLogInitiatorType {
  User = 'USER',
  ApiClient = 'API_CLIENT'
}
